var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ViewInRoomSvg = /* @__PURE__ */ __name(function ViewInRoomSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M44.81,9V26.61H27.19V9H44.81m5.5-5.5H21.69V32.11H50.31V3.5Z"
  }), /* @__PURE__ */ React.createElement("path", {
    style: {
      fill: "#231f20"
    },
    d: "M68.35,45.84H3.7V59.16h8.7v9.68h5V59.16H55.91v9.68h5V59.16h7.44Zm-5,8.32H8.7V50.84H63.35Z"
  }));
}, "ViewInRoomSvg");
var ViewInRoomIcon = /* @__PURE__ */ __name(function ViewInRoomIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ViewInRoomSvg
  }, props));
}, "ViewInRoomIcon");
export {
  ViewInRoomIcon
};
